
export enum TableExportTypes {
  MoviesRequests = 'MoviesRequests',
  CampaignsStatistics = 'CampaignsStatistics',
  Cinemas = 'Cinemas',
  Distributors = 'Distributors',
  Employees = 'Employees',
  TechnicalDevices = 'TechnicalDevices',
  ScannerDevices = 'ScannerDevices',
  ReleaseNotes = 'ReleaseNotes',
  ActivationOrders = 'ActivationOrders',
  Invoices = 'Invoices',
  Mandators = 'Mandators',
  News = 'News',
  SubscribersStatistics = 'SubscribersStatistics',
  OnlineTransactions = 'OnlineTransactions',
  AllTransactions = 'AllTransactions',
  Sessions = 'Sessions',
  Snippets = 'Snippets',
  BouncedEmails = 'BouncedEmails',
  EmployeesActivity = 'EmployeesActivity',
  FiskalyOverview = 'FiskalyOverview',
  FisklayMandatorDetails = 'FisklayMandatorDetails',
  SoldTicketByMandators = 'SoldTicketByMandators',
  CancelledVouchers = 'CancelledVouchers',
  ControlTicketQuantityTurnover = 'ControlTicketQuantityTurnover',
  ControlTicketQuantityTurnoverForYear = 'ControlTicketQuantityTurnoverForYear',
  MandatorFiskalyClients = 'MandatorFiskalyClients',
  MandatorFees = 'MandatorFees',
  OnlineFees = 'OnlineFees',
  TseFees = 'TseFees',
  CancelledVouchersByMandator = 'TseFees',
  TransactionsWithoutTicketsSent = 'TransactionsWithoutTicketsSent',
  TicketFeeHistory = 'TicketFeeHistory',
  OnlineFeeHistory = 'OnlineFeeHistory',
  AllMandatorsFees = 'AllMandatorsFees',
  Companies = 'Companies',
  ConnectedCinemas = 'ConnectedCinemas',
  VoucherStatusHistory = 'VoucherStatusHistory',
  VoucherTransactions = 'VoucherTransactions',
  CardTransactions = 'CardTransactions',
  CardBonusHistory = 'CardBonusHistory',
  CardFreeEntries = 'CardFreeEntries',
  CardActionsHistory = 'CardActionsHistory',
  ControllingInvoices = 'ControllingInvoices',
  AspBillRechnungen = 'AspBillRechnungen',
  AspBillWeiterleitungen = 'AspBillWeiterleitungen',
  MovieShows = 'MovieShows',
  CustomerActions = 'CustomerActions',
  CustomerCards = 'CustomerCards',
  CustomerTransactions = 'CustomerTransactions',
  Customers = 'Customers',
  CustomerLogs = 'CustomerLogs'
}
